import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    DOWNLOAD_FILTER: 'Tipo de certificación',
    DOWNLOAD_FILTER_ALL: 'Todos ({{count}})',
    DOWNLOAD_FILTER_DIPLOMA: 'Certificados ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_COURSES: 'Certificados cursos ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_TRACKS: 'Certificados rutas ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_LIVE_SESSIONS:
      'Constancia de sesiones ({{count}})',
    DOWNLOAD_FILTER_PROOF: 'Constancia de cursos ({{count}})',
    DOWNLOAD_DIPLOMA: 'Certificado',
    DOWNLOAD_PROOF: 'CONSTANCIA',
    DOWNLOAD_DESCRIPTION_GENERAL:
      'En total lograste **{{diplomasCount}}** certificados y **{{certificateCount}}** constancias de participación',
    TYPE_CERTIFICATE: 'Tipo de certificado',
  },
};
